import { lazy, Suspense } from "react";
import CircularLoader from "../customs/loader/main";

const Main = lazy(() => import("../components/readyToMarket/main"));

const ReadyToMarket = () => {
  return (
        <Suspense fallback={<CircularLoader />}>
          <Main />
        </Suspense>
  );
};

export default ReadyToMarket;

